import { colors } from 'theme'

export const defaultThemeStyles = {
    deleteScheduleOdd: colors.greyLight,
    listItem: colors.blackLight,
}
